import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { take } from 'rxjs/operators';
import { AttendanceAdministrationService } from '../../admin360/attendance-administration/attendance-administration.service';
import { AbsentNotice } from '../../admin360/attendance-administration/review-absent-notices/absent-notice.model';
import { TylerMatTableDataSource } from '../angular-material/extended.class';
import { StudentService } from '../student/student.service';
import { ViewAttachmentsComponent } from '../view-attachments/view-attachments.component';

@Component({
  selector: 'app-view-absent-notice-history-dialog',
  templateUrl: './view-absent-notice-history-dialog.component.html',
  styleUrls: ['./view-absent-notice-history-dialog.component.css']
})
export class ViewAbsentNoticeHistoryDialogComponent implements OnInit {
  studentId: number;
  absentNotices: AbsentNotice[] = [];

  columnsToDisplay = ['StartDate', 'EndDate', 'Status', 'SubmittedBy', 'Attachment', 'Reason'];
  angularMatData = new TylerMatTableDataSource(this.absentNotices);

  _sort: MatSort;

  studentName: string;
  studentNumber: string;

  constructor(private dialogRef: MatDialogRef<ViewAbsentNoticeHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private attendanceAdminService: AttendanceAdministrationService,
    private studentService: StudentService) { }

  @ViewChild(MatSort) set sort(value: MatSort) {
    this._sort = value;
    this.angularMatData.sort = value;
  }

  get sort(): MatSort {
    return this._sort;
  }

  ngOnInit(): void {
    this.studentId = this.data.studentId;
    this.studentName = this.studentService.formatStudentName(this.data.selectedStudent.FirstName, this.data.selectedStudent.MiddleName, this.data.selectedStudent.LastName, null);
    this.studentNumber = '#' + this.data.selectedStudent.StudentNumber;
    this.getSelfCheckInOutSubmissionHistory();
  }

  getSelfCheckInOutSubmissionHistory() {
    this.attendanceAdminService.getAbsentNoticesByStudentIdAndYearId(this.studentId).pipe(take(1)).subscribe(absentNotice => {
      this.absentNotices = absentNotice;
      this.angularMatData.data = this.absentNotices;
    });
  }

  cancelClick() {
    this.dialogRef.close();
  }

  viwAttachments(id: number) {
    this.attendanceAdminService.getAbsentNoticeAttachmentById(id).pipe(take(1)).subscribe(attachment => {
      this.dialog.open(ViewAttachmentsComponent, {
        data: {
          attachments: attachment
        },
        disableClose: true,
        minWidth: '750px'
      });
    });
  }

}

